import { type FunctionalComponent, h } from '@stencil/core';

export const ConversationalSearchLabelWithSection: FunctionalComponent<{
  text: string; // Base sentence
  partial?: string; // By default bolded
  isNonBoldedGreen?: boolean; // Remove bolded style, add green color
}> = (props, children) => {
    const parts = props?.text?.split('{0}');

    // Function to get text and decide about partial sytling for {0}
    const getFormattedText = (text: string, isBold: boolean, isGreen = false) => {
        if (isGreen) return <span class="label-with-section-colored">{text}</span>;
        return isBold ? <strong>{text}</strong> : text;
    };

    // Function to check if text contains '{1}' and replace it with given children
    const renderChildren = (text: string) => {
        if (text.includes('{1}')) {
          const splitText = text.split('{1}');

          return (
            <span>
              {getFormattedText(splitText[0] ?? '', false)}
              {children}
              {splitText[1] ?? ''}
            </span>
          );
        }
        return getFormattedText(text ?? '', false);
    };

    // Return new HTML structure
    return (
      <span>
        {parts?.length > 1 ? (
          <span>
            {getFormattedText(parts[0] ?? '', false)}
            {props.partial && getFormattedText(props?.partial, true, props?.isNonBoldedGreen)}
            {renderChildren(parts[1] ?? '')}
          </span>
        ) : (
          renderChildren(props?.text ?? '')
        )}
      </span>
    );
};
